<script setup>
</script>

<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_i_527_7557)">
            <path
                d="M28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28C21.732 28 28 21.732 28 14Z"
                fill="url(#paint0_linear_527_7557)"
            />
        </g>
        <g filter="url(#filter1_d_527_7557)">
            <path
                d="M7.14383 14.5912L7.19534 14.6513L7.31341 14.7781L7.39497 14.8641L7.44004 14.9071C7.50873 14.9737 7.57741 15.0382 7.65468 15.1005L7.74699 15.18C7.83499 15.2531 7.923 15.324 8.01529 15.3949L8.05391 15.4207C8.14406 15.4852 8.23637 15.5475 8.32866 15.6055L8.39307 15.6463C8.49824 15.7087 8.60771 15.7688 8.71288 15.8247C9.34801 16.1515 10.0425 16.3465 10.7548 16.3978C11.467 16.4491 12.1823 16.3558 12.8576 16.1234C12.7649 15.9103 12.6332 15.7164 12.4691 15.5518C12.0077 15.09 11.6216 14.5584 11.3251 13.9765C10.9338 14.005 10.5408 13.9524 10.1707 13.8221C9.80064 13.6917 9.46135 13.4864 9.17405 13.2189C8.88676 12.9514 8.6576 12.6274 8.50091 12.2673C8.34422 11.9072 8.26337 11.5186 8.26337 11.1258C8.26337 10.733 8.34422 10.3444 8.50091 9.98426C8.6576 9.62414 8.88676 9.30022 9.17405 9.03272C9.46135 8.76522 9.80064 8.55988 10.1707 8.42952C10.5408 8.29916 10.9338 8.24658 11.3251 8.27506C11.6212 7.69361 12.0074 7.16268 12.4691 6.70194C12.6481 6.52114 12.8388 6.35242 13.0401 6.19691C11.9615 5.77884 10.7757 5.72688 9.66481 6.04902C8.55391 6.37116 7.57939 7.04957 6.89093 7.98003C6.20248 8.91049 5.83818 10.0415 5.85401 11.1994C5.86984 12.3573 6.26491 13.4779 6.97855 14.3891C7.03007 14.4579 7.08802 14.5267 7.14383 14.5912Z"
                fill="white"
            />
            <path
                d="M21.0416 13.6326C20.9079 13.4626 20.7646 13.3004 20.6123 13.1469C20.52 13.0545 20.4234 12.9685 20.3268 12.8826L20.2946 12.8417C20.1959 12.7579 20.095 12.6784 19.992 12.601C19.8954 12.5301 19.7924 12.4635 19.6894 12.399L19.6249 12.3582C19.5262 12.298 19.4232 12.24 19.318 12.1863C18.6819 11.8579 17.986 11.6618 17.2723 11.6098C16.5585 11.5577 15.8416 11.6507 15.1647 11.8833C15.2582 12.096 15.3898 12.2898 15.5532 12.4549C16.0144 12.9161 16.4005 13.4469 16.6972 14.028C17.0874 14.0017 17.4788 14.056 17.8471 14.1874C18.2154 14.3188 18.5529 14.5246 18.8385 14.792C19.1242 15.0594 19.3519 15.3827 19.5076 15.7418C19.6633 16.101 19.7436 16.4883 19.7436 16.8798C19.7436 17.2713 19.6633 17.6587 19.5076 18.0178C19.3519 18.377 19.1242 18.7003 18.8385 18.9676C18.5529 19.235 18.2154 19.4408 17.8471 19.5722C17.4788 19.7037 17.0874 19.7579 16.6972 19.7316C16.401 20.3131 16.0149 20.844 15.5532 21.3047C15.3739 21.4844 15.184 21.6531 14.9844 21.8098C16.0481 22.2211 17.2163 22.2765 18.3141 21.9678C19.412 21.659 20.3805 21.0028 21.0749 20.0971C21.7692 19.1915 22.1521 18.0851 22.1662 16.9435C22.1804 15.8018 21.8249 14.6863 21.1532 13.7637L21.0416 13.6326Z"
                fill="white"
            />
            <path
                d="M18.9045 9.10021C19.1922 9.3886 19.4149 9.73541 19.5574 10.1172C19.7 10.4991 19.7591 10.9071 19.7309 11.3138C20.3111 11.6121 20.8412 11.9993 21.302 12.4614C21.4821 12.6417 21.6506 12.8334 21.8065 13.0351C22.1501 12.1472 22.2478 11.1829 22.0893 10.244C21.9308 9.30507 21.5219 8.42645 20.9059 7.70094C20.29 6.97543 19.4897 6.42997 18.5897 6.12217C17.6896 5.81438 16.7233 5.75568 15.7928 5.95228C14.8622 6.14888 14.0019 6.59348 13.3029 7.23911C12.6038 7.88474 12.0918 8.70743 11.8211 9.62027C11.5504 10.5331 11.531 11.5022 11.7649 12.4252C11.9988 13.3482 12.4773 14.1908 13.1499 14.864C13.4817 15.1968 13.7265 15.6064 13.8625 16.0564C13.9985 16.5065 14.0216 16.9832 13.9297 17.4444C13.8378 17.9055 13.6338 18.3369 13.3357 18.7002C13.0377 19.0636 12.6547 19.3478 12.2208 19.5277C11.7868 19.7075 11.3153 19.7775 10.8479 19.7314C10.3805 19.6853 9.93169 19.5246 9.54115 19.2634C9.15061 19.0022 8.83041 18.6487 8.60888 18.234C8.38735 17.8194 8.27133 17.3565 8.27109 16.8863C8.27109 16.8218 8.27109 16.7573 8.27109 16.695C7.68993 16.3981 7.15901 16.0116 6.69777 15.5496C6.5182 15.3687 6.34975 15.1771 6.19336 14.9758C5.84929 15.864 5.75124 16.8289 5.9096 17.7683C6.06796 18.7078 6.47683 19.5869 7.09302 20.3129C7.70921 21.0389 8.50983 21.5848 9.41028 21.8929C10.3107 22.2009 11.2776 22.2597 12.2086 22.0631C13.1397 21.8664 14.0005 21.4216 14.6999 20.7756C15.3993 20.1296 15.9115 19.3065 16.1823 18.3931C16.453 17.4798 16.4724 16.5102 16.2382 15.5867C16.0041 14.6633 15.5252 13.8203 14.852 13.1469C14.3161 12.6103 14.015 11.8825 14.015 11.1236C14.015 10.3647 14.3161 9.63684 14.852 9.10021C15.388 8.56359 16.1149 8.26212 16.8729 8.26212C17.6309 8.26212 18.3578 8.56359 18.8938 9.10021H18.9045Z"
                fill="white"
            />
        </g>
        <defs>
            <filter
                id="filter0_i_527_7557"
                x="0"
                y="-2"
                width="28"
                height="30"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="-2" />
                <feGaussianBlur stdDeviation="2" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_527_7557"
                />
            </filter>
            <filter
                id="filter1_d_527_7557"
                x="4.83594"
                y="4.83838"
                width="18.3301"
                height="18.3384"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood
                    flood-opacity="0"
                    result="BackgroundImageFix"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset />
                <feGaussianBlur stdDeviation="0.5" />
                <feComposite
                    in2="hardAlpha"
                    operator="out"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_527_7557"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_527_7557"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_527_7557"
                x1="14"
                y1="31.5"
                x2="14"
                y2="-3.5"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#4896FF" />
                <stop
                    offset="1"
                    stop-color="#00B899"
                />
            </linearGradient>
        </defs>
    </svg>
</template>
